import { createFileRoute } from "@tanstack/react-router";
import { LocalesPage } from "@/components/registries/locales-page.js";

export const Route = createFileRoute("/_authenticated/configuration/registries/locales")({
  component: LocalesPage,
});
